export function escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

//# sourceMappingURL=escapeRegExp.js.map